// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2r4nI{margin-bottom:2.5rem}._2r4nI:last-child{margin-bottom:0}._3hUVy{display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-wrap:nowrap;flex-wrap:nowrap;margin-bottom:1.5rem}._3OQhK{-ms-flex-item-align:end;align-self:flex-end}._29u_d{color:#00f;display:-ms-flexbox;display:flex;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-ms-flex-align:center;align-items:center;height:24px;height:1.5rem;padding:.125rem 0;font-size:16px;font-size:1rem;font-weight:500;line-height:20px;line-height:1.25rem;font-family:var(--heading-font);letter-spacing:var(--letter-spacing)}._3Ofjk path[fill]{fill:#00f}._2-Ozt{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));grid-column-gap:1rem;grid-row-gap:1.25rem;min-height:326.75px;min-height:20.421875rem}@media(max-width:1023px){._2-Ozt{grid-template-columns:repeat(2,minmax(0,1fr))}}@media(max-width:767px){._2-Ozt{grid-template-columns:minmax(0,1fr)}}", ""]);
// Exports
exports.locals = {
	"root": "_2r4nI",
	"header": "_3hUVy",
	"headerLeft": "_3OQhK",
	"moreButton": "_29u_d",
	"moreButtonIcon": "_3Ofjk",
	"courseList": "_2-Ozt"
};
module.exports = exports;
